module.exports = __webpack_public_path__ + "static/media/marcos_acuna.85f1ea61.jpg";